import { render, staticRenderFns } from "./AmazeTermsViewer.vue?vue&type=template&id=7b9b0246&scoped=true"
import script from "./AmazeTermsViewer.vue?vue&type=script&lang=js"
export * from "./AmazeTermsViewer.vue?vue&type=script&lang=js"
import style0 from "./AmazeTermsViewer.vue?vue&type=style&index=0&id=7b9b0246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b0246",
  null
  
)

export default component.exports